var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"},on:{"click":function($event){return _vm.on_click()}}},[_c('path',{attrs:{"d":"M10.59 0.589966L6 5.16997L1.41 0.589966L0 1.99997L6 7.99997L12 1.99997L10.59 0.589966Z","fill":_vm.fill_color,"fill-opacity":_vm.opacity}})])
}
var staticRenderFns = []

export { render, staticRenderFns }